export default {
  title: 'Tipp',
  description: 'Klicken Sie auf den Produktnamen um detaillierte Informationen und Allergene anzuzeigen!',
};
